import React, { useState } from 'react';
import { ConciliationGrid } from './ConciliationGrid';
import Select from 'react-select';
import { styleSelect, themeSelect } from '../../../../../rbts/assets/ts/_utils';
import { useObtenerDiasPorEvento } from '../../cortesias/hooks/CortesiasHook';

type Props = {};

const tipos = [
  { id: 1, value: 1, label: 'Puntos de venta' },
  { id: 2, value: 2, label: 'Juegos' },
];

const View: React.FC<Props> = ({}) => {
  const [reloadInfo] = useState<number>(Math.random() * 40);
  const [diasSeleccionados, setDiasSeleccionados] = useState<any[]>([]);
  const [idTipo, setIdTipo] = useState<number>(0);
  const [tipoSeleccionado, setTipoSeleccionado] = useState<any | null>([]);

  const { list: listadosDeDias, loadingRequest: cargandoDias } =
    useObtenerDiasPorEvento(reloadInfo);

  const idsDia = diasSeleccionados.map((d: any) => d.value as number);
  const strDate = diasSeleccionados.map((d: any) => d.label).join(', ');

  const handleTipoOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setTipoSeleccionado(selectedOption);
      setIdTipo(selectedOption.id);
    } else {
      setTipoSeleccionado(null);
      setIdTipo(0);
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="d-flex flex-column flex-xl-row">
              <div className="flex-lg-row-fluid">
                <div className="card mb-6 mb-xl-9">
                  <div className="card-header border-0">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Búsqueda
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                        <div className="w-300px pe-5 fs-7 text-gray-700">
                          <div className="w-100 d-flex">
                            <label className="form-label w-auto">
                              Día administrativo:{' '}
                            </label>
                          </div>
                          <Select
                            options={listadosDeDias}
                            value={diasSeleccionados}
                            styles={styleSelect}
                            theme={themeSelect}
                            classNamePrefix="tc-select"
                            placeholder={'Seleccione uno o varios días...'}
                            className="w-100"
                            isSearchable={true}
                            isMulti
                            closeMenuOnSelect={false}
                            noOptionsMessage={() => {
                              return (
                                <span>{'No se encontraron registros'}</span>
                              );
                            }}
                            onChange={(opts: any) => setDiasSeleccionados(opts ?? [])}
                            isLoading={cargandoDias}
                            isClearable
                          />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                        <div className="w-300px pe-5 fs-7 text-gray-700">
                          <div className="w-100 d-flex">
                            <label className="form-label w-auto">Tipo: </label>
                          </div>
                          <Select
                            options={tipos}
                            value={tipoSeleccionado}
                            styles={styleSelect}
                            theme={themeSelect}
                            classNamePrefix="tc-select"
                            placeholder={'Todos'}
                            className="w-100"
                            isSearchable={true}
                            noOptionsMessage={() => {
                              return (
                                <span>{'No se encontraron registros'}</span>
                              );
                            }}
                            onChange={handleTipoOnChange}
                            isClearable
                            backspaceRemovesValue
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="d-flex flex-column flex-xl-row">
              <div className="flex-lg-row-fluid">
                <div className="card mb-6 mb-xl-9">
                  <div className="card-header border-0">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Conciliaciones realizadas
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <ConciliationGrid
                          reloadGrid={reloadInfo}
                          strDate={strDate}
                          idsDia={idsDia}
                          idTipo={idTipo}
                        ></ConciliationGrid>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
